import { mergeStyles, useTheme } from '@fluentui/react';
import React from 'react';
import { Datepicker } from '../@mobiscroll/react';
import '../@mobiscroll/react/dist/css/mobiscroll.react.min.css';
import './MobiscrollDatepicker.css';

export interface DatepickerProps {
  onCancel?: () => void;
  onChange?: (date: Date) => void;
  onDone?: (date: Date) => void;
  defaultValue?: Date;
  placeholder?: string;
  min?: string;
  max?: string;
}

export const MobiscrollDatepicker = (props: DatepickerProps): JSX.Element => {
  const { onCancel, onChange, onDone, defaultValue, placeholder } = props;
  const [dateValue, setDateValue] = React.useState<Date>();
  const theme = useTheme();

  return (
    <div
      className={mergeStyles({
        '& .mbsc-ios.mbsc-textfield': {
          fontFamily: `${theme.fonts.medium.fontFamily}`,
          fontSize: theme.fonts.medium.fontSize,
          color: dateValue && `${theme.palette.white}`,
        },
      })}
    >
      <Datepicker
        inputStyle="box"
        controls={['date']}
        touchUi={true}
        theme="ios"
        themeVariant="light"
        onChange={(event) => {
          setDateValue(event.value);
          onDone && onDone(event.value);
          onChange && onChange(event.value);
        }}
        onCancel={onCancel}
        defaultSelection={defaultValue}
        placeholder={placeholder}
      />
    </div>
  );
};
